<ion-item
  lines="none"
  button
  detail="false"
  *ngIf="option && option.choices && option.choices.length > 0 && selectedLang"
  [disabled]="finalPriceLoading"
  (click)="openPopup()"
>
  <ion-label *ngIf="displayValue" class="ion-text-wrap">
    {{ displayValue }}
  </ion-label>
  <ion-label *ngIf="!displayValue" class="ion-text-wrap placeholder">
    {{ "write-here" | translate }}
  </ion-label>
</ion-item>
